module.exports = __webpack_public_path__ + "assets/media/evening.d629477e.mp3";